const getDefaultDates = () => {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
  const tomorrowMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, 0, 0, 0);

  return { startOfMonth, tomorrowMidnight };
};

export default getDefaultDates;
